<pre>{{deliveryNoteTransferService.vehicle$ | async | json}}</pre>
<qpoint-delivery-note-transfer [vehicle]="deliveryNoteTransferService.vehicle$.asObservable() | async"></qpoint-delivery-note-transfer>
